"use strict";

import React from "react";
import FaDownload from "react-icons/lib/fa/download";

require("styles//SagePage.css");

class SagePageComponent extends React.Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.state = {
      downloadLinks: [],
      conditionsAccepted: false,
    };
  }

  handleInputChange() {
    this.setState({
      conditionsAccepted: !this.state.conditionsAccepted,
    });
  }

  componentDidMount() {
    return fetch("/api/v1/sagesetup/")
      .then((response) => response.json())
      .then((responseJson) => {
        this.setState({
          downloadLinks: responseJson,
        });
      })
      .catch(() => { });
  }

  render() {
    const downloadLinks = this.state.downloadLinks.map((link) => (
      <a
        className="download-link"
        disabled={!this.state.conditionsAccepted}
        key={link.title}
        href={
          this.state.conditionsAccepted
            ? link.file.replace("/api/v1/sagesetup", "")
            : ""
        }
      >
        <FaDownload /> {link.title}
      </a>
    ));
    return (
      <div className="sagepage-component">
        <div className="header">
          <h2 className="page-title">Downloads</h2>
          <div className="page-description">
            <p>
              Nesta página, encontrará tudo o que precisa para instalar o seu software de forma simples, segura e eficiente. Antes de prosseguir, é fundamental seguir alguns passos essenciais para garantir o sucesso da instalação e evitar interrupções no seu sistema.
              Siga as instruções fornecidas e descarregue os ficheiros necessários com confiança. Caso precise de apoio, a nossa equipa técnica está disponível para o ajudar em qualquer etapa.
            </p>
          </div>
        </div>
        <section>
          <h3 className="section-title">Downloads</h3>
          <h4>Condições de Utilização</h4>
          <p>
            Antes de proceder à instalação do setup no seu computador ou na sua
            rede tem que respeitar os seguintes passos:
          </p>
          <ol>
            <li>
              Contactar a Labor Team para que, antecipadamente, sejam
              verificadas as condições necessárias à instalação dos setups;
            </li>
            <li>
              Efetuar uma cópia de segurança de todas as bases de dados Sage
              existentes no seu computador (aconselhamos que efetuem sempre
              cópias adicionais para suportes externos);
            </li>
            <li>
              Colocar o UAC (User Access Control) no nível mais baixo (existem
              sistemas operativos que obrigam a reiniciar o Windows);
            </li>
            <li>
              Parar o antívirus e outros programas de malware até terminar a
              instalação dos setups;
            </li>
            <li>Executar sempre os setups com permissões de Administrador;</li>
            <li>
              Em caso de dúvidas a instalação deverá ser efectuada por um
              técnico da Labor Team.
            </li>
          </ol>
          <label>
            <input
              name="conditionsAccepted"
              type="checkbox"
              checked={this.state.conditionsAccepted}
              onChange={this.handleInputChange}
            />{" "}
            Confirmo que li e aceito todas as condições de utilização.
          </label>
          <div className="download-links">{downloadLinks}</div>
        </section>
      </div>
    );
  }
}

SagePageComponent.displayName = "SagePageComponent";

// Uncomment properties you need
// SagePageComponent.propTypes = {};
// SagePageComponent.defaultProps = {};

export default SagePageComponent;



// WEBPACK FOOTER //
// ./src/components/DownloadsPageComponent.js